module.exports = __webpack_public_path__ + "img/common-file-text-question.55035386.svg";